
// pages/MyJobs.jsx
import React from "react";
import { FaRegBookmark } from "react-icons/fa";

const MyJobs = () => {
  return (
    <div className="w-full max-w-5xl mx-auto px-4 py-8">
      <h2 className="text-3xl font-bold mb-6">My Jobs</h2>

      <div className="flex gap-10 border-b  mb-10">
        <button className="pb-2 border-b-4 border-black  font-semibold">Saved</button>
        <button className="pb-2 text-gray-500 hover:text-black">Applications</button>
      </div>

      <div className="text-center text-gray-700 mt-20">
        <div className="flex justify-center mb-4">
          <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100">
            <FaRegBookmark className="text-2xl text-gray-400" />
          </div>
        </div>
        <p className="font-semibold text-lg text-black">No saved jobs yet</p>
        <p className="text-sm text-gray-500 mt-1 mb-4">Saved jobs will be displayed here</p>
        <button className="hover:bg-[#004349] bg-black font-bold text-white px-6 py-2 rounded-lg  text-sm">
          Find Jobs
        </button>
      </div>
    </div>
  );
};

export default MyJobs;
